/**
 * Converts a given object-based mapping of keys to values, to a list of options compatible with a select / dropdown input
 * @returns an array of options each with shape { label: string, key: any }
 */
export const convertMapToOpts = <T extends Record<string, string>>(
  /** object-based mapping of keys to values. no restrictions on the type of the value. */
  map: T,
  /** a predicate that is applied to each key/value in the provided map to get the label for each option. provide null to not apply any transformation. */
  labelTransformer:
    | (([key, value]: [keyof T, T[keyof T]]) => string)
    | null = ([key]) =>
    typeof key === "string" ? key.toLowerCase().replace(/_/g, " ") : String(key)
) =>
  map?.constructor === Object
    ? Object.entries(map).map(([key, value]) => ({
        label:
          labelTransformer && typeof labelTransformer === "function"
            ? labelTransformer([key, value] as [keyof T, T[keyof T]])
            : key,
        value,
      }))
    : [];
